import { render, staticRenderFns } from "./StallDialog.vue?vue&type=template&id=ccbc521a"
import script from "./StallDialog.vue?vue&type=script&lang=js"
export * from "./StallDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports